import { render, staticRenderFns } from "./yxaccount.vue?vue&type=template&id=3e3f9360&scoped=true&"
import script from "./yxaccount.vue?vue&type=script&lang=js&"
export * from "./yxaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f9360",
  null
  
)

export default component.exports